import { RouterOutlet } from "@angular/router";

import { CdkMenuModule } from "@angular/cdk/menu";
import { OverlayModule } from "@angular/cdk/overlay";

import { Component } from "@angular/core";
import { NgbCollapseModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "hawk-root",
  imports: [RouterOutlet, NgbCollapseModule, NgbDropdownModule, CdkMenuModule, OverlayModule],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  host: {
    class: "app-page",
  },
})
export class AppComponent {}
